import React from 'react';
import PropTypes from 'prop-types';
import {I18n} from 'react-redux-i18n';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';

export default class AdminConfigSection extends React.PureComponent {

  static propTypes = {
    id: PropTypes.string,
    title: PropTypes.string,
    defaultExpanded: PropTypes.bool
  };

  render() {
    const {id, title, defaultExpanded} = this.props;

    return (
      <ExpansionPanel id={id} defaultExpanded={defaultExpanded}>
        <ExpansionPanelSummary id="dvrToolkitPanel" expandIcon={<ExpandMoreIcon />}>
          <Typography variant="h3">
            {I18n.t(title)}
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          {this.props.children}
        </ExpansionPanelDetails>
      </ExpansionPanel>
    );
  }

}